"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SF = function SF(props) {
  var size = props.size;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: size,
    height: size,
    preserveAspectRatio: "xMidYMid slice",
    clipRule: "evenodd",
    fillRule: "evenodd",
    viewBox: "0 0 652 652",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#FD5A1E",
    d: "M292.1,294v50.3c0,0,64,4.1,83.6-7.7c-3.5,11.1-2.4,47.5,0,53.5c-24.8-12.7-83.6-7.6-83.6-7.6v50.7h94.8 l20.2-23.5v-86.8l-23.4-27.2C369.7,294.2,320,294,292.1,294L292.1,294z M145.4,114c19.7-9.4,40.6-29.2,48.1-42.6 c19,9,193.4,7.6,213.5,0c12.2,17.8,25.2,27.7,43.7,33.7c-1.7,17.1-1.2,23.1,4.4,36.8h-48l-20.2-22.5h-171l-22.4,19.7v90.7l22.3,21.6 l28.3,1.2c0-33.7,0.3-40.1-24.4-46.7c8.2-16.5,9.9-18.5,12.1-39.1c21.2,7.1,240.4,3.2,249.9-2.2c-1.5,21.5,10.6,62.2,18.7,77.5h-48 c-2.4-16.7-13-29.6-29.7-32.7H292.1v43.2c0,0,101.5,2.8,114.9-1.8c6.7,17.3,30.7,42.8,48,49.8c-5.8,35.4-4.7,95.9,0,132.6 c-18.9,9.4-38.2,28.6-48,48.1c-23.9-6.6-115-3.3-115-3.3V505c4.7,18.5,14.7,23,32.1,24.5c0,0-14,26.4-14.6,41.9h-82.1 c-0.4-15.1-14.6-41.9-14.6-41.9c15.8-0.7,28.7-10.1,31.1-24.5v-27.2c0,0-28.8-1.1-50.6,3.3c-6.6-14.8-30.6-41.3-48.1-48.1 c4-10.6,2.2-76.9-3.7-90.9h51.8l0,67.5l20.2,23.5H244V294c0,0-26.6-1.3-50.6,0.5c-6.9-13.4-27.4-34.9-48.1-45.1 C151.9,224.9,152.4,137.1,145.4,114L145.4,114z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#FD5A1E",
    d: "M344.8,551.3H339v15.9H335v-15.9h-5.8v-3.5h15.6L344.8,551.3L344.8,551.3z M371.2,567.1h-3.9v-15.4h-0.1 l-5.6,15.4h-3.8l-5.4-15.4h-0.1v15.4h-3.9v-19.3h6.8l4.5,12.6h0.1l4.7-12.6h6.8L371.2,567.1L371.2,567.1z"
  }));
};

SF.propTypes = {
  size: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
SF.defaultProps = {
  size: '100'
};
var _default = SF;
exports["default"] = _default;